import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
let refreshRequest = null;

function getCsrfToken() {
  const cookie = document.cookie.split(';').find((entry) => entry.trim().startsWith('csrf-token='));
  return cookie ? decodeURIComponent(cookie.trim().slice('csrf-token='.length)) : null;
}

export function refreshAdminSession() {
  if (!refreshRequest) {
    const csrfToken = getCsrfToken();
    refreshRequest = axios.post(`${API_URL}/api/admin/auth/refresh`, {}, {
      withCredentials: true,
      headers: csrfToken ? { 'X-CSRF-Token': csrfToken } : undefined
    }).finally(() => {
      refreshRequest = null;
    });
  }
  return refreshRequest;
}

export function installAdminSessionRefresh(client) {
  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      const request = error.config;
      if (error.response?.status !== 401 || !request) {
        return Promise.reject(error);
      }

      if (request._adminRefreshAttempted) {
        window.location.href = '/login';
        return Promise.reject(error);
      }

      request._adminRefreshAttempted = true;
      try {
        await refreshAdminSession();
        return client(request);
      } catch (refreshError) {
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
  );
}
